<template>
    <tr class="setItems__item">
        <td>{{ quantity }}x</td>
        <td colspan="9" class="flex-grow-1 ml-2">{{$t('components.BasketPackGift.gift')}} {{ name }}</td>
    </tr>
</template>

<script>
    export default {
        props: ['item'],
        computed: {
            name: function () {
                return this.item.name
            },
            quantity: function () {
                return this.item.quantity
            },
        }
    };
</script>
